/* eslint-disable @typescript-eslint/no-unused-vars */
import type { DefaultRootState } from "react-redux";

export interface DependentFeatureFlags {}

export const getFeatureFlagsForEngine = (state: DefaultRootState) => {
  return {};
};
